import { CUSTOM_CALCULATION_DATA_FIELD_KEY_PREFIX } from '../../constants/dataFieldKeys/customCalculationDataFieldKey';

export const isSpecialEvent = (key: string): boolean => {
  return (
    key.startsWith('skan__') || key.startsWith('unified_total__') || key.startsWith(CUSTOM_CALCULATION_DATA_FIELD_KEY_PREFIX)
  );
};
